// extracted by mini-css-extract-plugin
module.exports = {"orange":"#e38826","darkCyan":"#006970","veryDarkCyan":"#004241","footer":"css-1a383fe"};